export default __webpack_public_path__ + "static/irish-healthcare-award-bbcdf3b9dc18466ad0991fbcb3551a28.png";